export class httpConfiguratorService {
	/**
	 *
	 * @param $http
	 * @param CONFIG
	 */
	constructor($http, CONFIG) {
		"ngInject";
		this.$http = $http;
		this.CONFIG = CONFIG;
		this.sessionKey = "Authorization";
	}

	setDefaultsHeaders() {
		let headers = this.$http.defaults.headers;
		let contentType = this.CONFIG.ContentType;
		if (process.env.ENV === "development") {
			this.$http.defaults.headers.common["X-Origin"] = "http://localhost:3000";
		}
		if (undefined === headers.common["Content-Type"]) {
			this.$http.defaults.headers.common["Content-Type"] = contentType;
		}
		if (undefined === headers.Accept) {
			this.$http.defaults.headers.Accept = contentType;
		}
	}

	setHeaders(token) {
		if (undefined === this.$http.defaults.headers.common[this.sessionKey]) {
			this.$http.defaults.headers.common[this.sessionKey] = token;
		}
	}

	clearHeaders() {
		delete this.$http.defaults.headers.common[this.sessionKey];
	}
}


// WEBPACK FOOTER //
// ./sources/services/http.js